import { mapActions, mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters({
            loggedInStatus: 'auth/getLoginStatus',
            openedDropdown: 'header/getOpenedDropdown'
        }),
    },
    mounted() {
    },
    methods: {
        ...mapActions({
            mutateOpenDropdown:'header/mutateOpenDropdown',
            mutateCloseDropdown:'header/mutateCloseDropdown'
        }),
        openUserMenu(menutype) {
            if(this.loggedInStatus) {
                if(this.isMobile()) {
                    this.$router.push({ name: 'account-data' });
                } else {
                    this.mutateOpenDropdown(menutype);
                }
            } else {                
                if(this.$route.name != 'login') {
                    this.$router.push({ name: 'login' });
                }               
            }
        },

        toggleDropdownMenu(menutype) {      
            if(menutype == 'useraccount') {
                this.openUserMenu(menutype);
            } else {
                this.mutateOpenDropdown(menutype);
            }
        },
        closeDropdownMenu() {
            this.mutateCloseDropdown();
        }
    }
}
